/**
 * Reducer for obtaining flight routes
 */
import Constants from '../constants/PassengerConstants';
import { Map as IMap } from 'immutable';

const initialState = IMap({
  id: '', // contact_objectid - id: '4646', (String),
  firstName: '', // fname - firstName / name: 'John', (String)
  lastName: '', // lname - lastName / surname: 'Doe', (String)
  relationshipType: '', // relationshiptype_objectid - relationshipId / relationshipTypeId: '519'
  birthday: '', // contactDOB - dob / birthday: '06/25/1999', (String - date format)
  age: '', // age - age: '33', (String)
  ageStatus: '', // agestatus - ageStatus: 'Adult', (String)
  phone: '', // primaryPhone: '808-552-5555', (string)
  infant: 0, // is_infant - infant: '', (int ?)
  editable: 1, // is_infant - infant: '', (int ?)
  email: '', // email._cdata - email: 'john@doe.com', (String)
  gender: '', // gender: 'male', (String)
});

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function passenger (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.SAVE_PASSENGER_REQUEST:
    case Constants.PASSENGER_REQUEST:
      return initialState;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.SAVE_PASSENGER_SUCCESS:
    case Constants.PASSENGER_SUCCESS:
      return IMap(action.data);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.SAVE_PASSENGER_FAILURE:
    case Constants.PASSENGER_FAILURE:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/PassengerReducer.js